import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptBar } from "@Local/Dashboard/dashboard.util";
/********* 主要退會原因分析 *********/
const QuitReasons = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["時間不配和", "遷居", "經濟/工作變動"],
			data: [12, 10, 9],
		},
	} = props;
	const { data = [], axisLabels = [] } = adaptBar(sourceData);
	const isLoading = data.length === 0;
	const title = "主要退會原因分析";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			formatter: params => {
				const item = params[0];
				return `${item.name}<br/>${item.marker} ${item.value} 人`;
			},
		},
		grid: {
			left: 150,
			right: 20,
			top: 60,
			bottom: 20,
		},
		xAxis: [
			{
				type: "value",
				splitNumber: 5,
				axisLabel: { show: false },
				axisTick: { show: false },
				axisLine: { show: false },
				splitLine: {
					lineStyle: {
						type: "dashed",
						color: "#E5E7EB",
					},
				},
			},
		],
		yAxis: [
			{
				type: "category",
				inverse: true,
				data: axisLabels,
				axisTick: { show: false },
				axisLine: { show: false },
				axisLabel: {
					fontSize: 14,
					color: "#374151",
					margin: 10,
				},
			},
		],
		series: [
			{
				name: "Value",
				type: "bar",
				barWidth: "50%",
				data: data,
				itemStyle: {
					color: "#5B0F74",
					borderRadius: [0, 6, 6, 0],
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default QuitReasons;
